export default "__VITE_ASSET__C06owYpK__"